// TODO: File being used in new algolia_search folder. move it for clarity later
import { currentRefinements } from 'instantsearch.js/es/widgets'
import { capitalize } from '../../../../utils/stringHelpers'
import { excludedAttributesForCurrentRefinements, excludedAttributesForPageCurrentRefinements } from '../../../../utils/search/filters'
import { pathLeaf, withoutLandingScopeCategoryRefinements } from '../../../../utils/search/categoryPaths'
import { t } from '../../../../utils/search/translations'
import { currencySymbol, gbpToDisplayOrAnchor } from '../../../../utils/search/currency'

function convertOperatorToWord (operator) { return operator === '<=' ? t('below') : t('above') }

function getPriceLabel (refinement) {
  if (!refinement) return ''
  return `${convertOperatorToWord(refinement.operator)} ${currencySymbol()}${gbpToDisplayOrAnchor(refinement.value).toLocaleString()}`
}

function getDiscountLabel (refinement) {
  if (!refinement) return ''
  return `${convertOperatorToWord(refinement.operator)} ${refinement.value}${t('percent_off')}`
}

function getDimensionsLabel (refinement) {
  if (!refinement) return ''
  return `${capitalize(refinement.attribute.replace('_float', ''))}: ${convertOperatorToWord(refinement.operator)} ${refinement.value}cm`
}

function getNumbersOfLabel (refinement) {
  if (!refinement) return ''

  let attributeText = ''
  if (refinement.value === 1) {
    const attributeToSingular = {
      number_of_doors: 'door',
      number_of_drawers: 'draw',
      number_of_shelves: 'shelf',
      number_of_seats: 'seat'
    }
    attributeText = attributeToSingular[refinement.attribute]
  } else {
    attributeText = refinement.attribute.replace('number_of_', '')
  }
  return `${refinement.value} ${attributeText}`
}

function getNumberOfSeatsLabel (refinement) {
  if (!refinement) return ''
  if (refinement.value === 4) {
    return t('four_seater_and_more')
  } else {
    return `${refinement.value}${t('seater_suffix')}`
  }
}

function getDeliveryLabel (refinement) {
  if (!refinement) return ''
  const deliveryLabelMap = {
    // TODO: Remove later - keep now for back compat
    free_london_delivery_for_algolia: t('free_london_delivery'),
    free_uk_delivery_for_algolia: t('free_uk_delivery'),
    in_time_for_christmas_for_algolia: t('in_time_for_christmas'),
    free_collection: t('free_collection')
  }
  return deliveryLabelMap[refinement.attribute]
}

function getSellerAttributeLabel (refinement) {
  if (!refinement) return ''
  const sellerAttributeLabelMap = {
    top_score_seller: t('top_sellers_only'),
    professional_seller: t('professional_sellers_only')
  }
  return sellerAttributeLabelMap[refinement.attribute]
}

function getSaleAttributeLabel (refinement) {
  if (!refinement) return ''
  const saleAttributeLabelMap = {
    sale: t('on_sale')
  }
  return saleAttributeLabelMap[refinement.attribute]
}

function getTradeAttributeLabel (refinement) {
  if (!refinement) return ''
  const tradeAttributeLabelMap = {
    trade_price_and_trade_price_under_sale_price: t('trade_price_only')
  }
  return tradeAttributeLabelMap[refinement.attribute]
}

function getCategoryLeafLabel (refinement) {
  if (!refinement) return ''
  return pathLeaf(refinement.label)
}

function getProfessionalDetailLabel (refinement) {
  if (!refinement) return ''
  const ProfessionalAttributeLabelMap = {
    professionally_reupholstered: t('professionally_reupholstered'),
    reupholstery_available: t('reupholstery_available'),
    professionally_refurbished: t('professionally_refurbished'),
    professionally_cleaned: t('professionally_cleaned'),
    certificate_of_authenticity: t('certificate_of_authenticity'),
    signed_by_artist: t('signed_by_artist'),
    sustainable_packaging: t('sustainable_packaging')
  }
  return ProfessionalAttributeLabelMap[refinement.attribute]
}

function getCustomLabels (refinement = null) {
  return {
    display_price_for_algolia: getPriceLabel(refinement),
    display_price_trade_user_for_algolia: getPriceLabel(refinement),
    width_float: getDimensionsLabel(refinement),
    height_float: getDimensionsLabel(refinement),
    depth_float: getDimensionsLabel(refinement),
    number_of_doors: getNumbersOfLabel(refinement),
    number_of_drawers: getNumbersOfLabel(refinement),
    number_of_shelves: getNumbersOfLabel(refinement),
    number_of_seats: getNumberOfSeatsLabel(refinement),
    sale_percentage_int: getDiscountLabel(refinement),
    set_of: getNumbersOfLabel(refinement),
    free_uk_delivery_for_algolia: getDeliveryLabel(refinement),
    free_london_delivery_for_algolia: getDeliveryLabel(refinement),
    free_collection: getDeliveryLabel(refinement),
    in_time_for_christmas_for_algolia: getDeliveryLabel(refinement),
    top_score_seller: getSellerAttributeLabel(refinement),
    professional_seller: getSellerAttributeLabel(refinement),
    sale: getSaleAttributeLabel(refinement),
    professionally_reupholstered: getProfessionalDetailLabel(refinement),
    reupholstery_available: getProfessionalDetailLabel(refinement),
    professionally_refurbished: getProfessionalDetailLabel(refinement),
    professionally_cleaned: getProfessionalDetailLabel(refinement),
    certificate_of_authenticity: getProfessionalDetailLabel(refinement),
    signed_by_artist: getProfessionalDetailLabel(refinement),
    sustainable_packaging: getProfessionalDetailLabel(refinement),
    trade_price_and_trade_price_under_sale_price: getTradeAttributeLabel(refinement),
    category_paths: getCategoryLeafLabel(refinement)
  }
}

function buildCustomLabel (item) {
  return {
    ...item,
    refinements: item.refinements.map(refinement => {
      return {
        ...refinement,
        label: getCustomLabels(refinement)[refinement.attribute]
      }
    })
  }
}

function buildRefinementsWidget (container, excludedAttributes) {
  return currentRefinements({
    container,
    excludedAttributes,
    cssClasses: {
      label: 'hidden'
    },
    transformItems (items) {
      if (items === []) return
      return withoutLandingScopeCategoryRefinements(items).map(item => {
        if (Object.keys(getCustomLabels()).includes(item.attribute)) {
          return buildCustomLabel(item)
        } else {
          return item
        }
      })
    }
  })
}

function buildCurrentRefinements () {
  return buildRefinementsWidget('.current-refinements__results', excludedAttributesForCurrentRefinements())
}

function buildPageCurrentRefinements () {
  return buildRefinementsWidget('.current-refinements__results-page', excludedAttributesForPageCurrentRefinements())
}

export { buildCurrentRefinements, buildPageCurrentRefinements }
